import { Col, Row } from "react-bootstrap";

import ContactData from "../../data/contact.json"
import React from "react";

export const Privacy = () => {

	const rowStyle = {
		color: 'white',
		backgroundColor: 'black',
		padding: '5vh 10vw  20vh  10vw',
	};


	return (
		<Row style={rowStyle}>
			<Col md={12} className="">
			<h2 className="text-center"><strong >Privacy Policy</strong></h2><br /><br />
				<p>
					In accordance with the General Data Protection Regulation (GDPR) of the European Union and the Italian national laws on personal data protection, this Privacy Policy describes the practices of Ducato S.R.l. (hereinafter "we," "our," or "company") regarding the management of personal data within the context of our website.
				</p>
				<p>
					<strong>Data Collection</strong><br />
					Our website, accessible at the address {ContactData.siteAdress}, does not collect any type of personally identifiable information. We do not use cookies or other tracking technologies to monitor user activity. We respect your privacy and do not record personal or identifiable information during your visit.
				</p>
				<p>
					<strong>Automatic Data</strong><br />
					The provider that hosts our web server may automatically collect certain non-personal information during navigation, such as the IP address of the device used to access the site, the type of browser, the operating system, and the pages visited. These are traffic data, which by their nature are not collected to be immediately associated with identified individuals but could, through processing or association with data held by third parties, allow the identification of users/visitors to the site. This data is used solely to ensure the proper functioning of the website and is deleted immediately after processing.
				</p>
				<p>
					<strong>Purposes of Processing</strong><br />
					We do not collect personal data, and we do not process any information to identify users. We do not sell, share, or transfer personal data to third parties.
				</p>
				<p>
					<strong>Data Subject Rights</strong><br />
					According to current laws, you have specific rights regarding your personal data, even if it is not collected by our site. You have the right to request information about the processing of data, to access any processed personal data, to correct any inaccurate data, and to object to processing. To exercise these rights or to ask questions about our privacy policy, you can contact us using the contact details provided below.
				</p>
				<p>
					<strong>Contact</strong><br />
					{ContactData.name}<br />
					<span dangerouslySetInnerHTML={{ __html: ContactData.adressMain }} /><br />
					Vat: {ContactData.vat}<br />
					Email: <a href={`mailto:${ContactData.emailAddress}`} style={{color:'white'}}>{ContactData.emailAddress}</a>
				</p>
				<p>
				<strong>Updates</strong><br />
					This Privacy Policy is subject to changes and updates. We recommend checking it periodically to stay informed about our data processing practices.
					<br />
					Last update: October 30, 2023
				</p>

			</Col>
		</Row>
	);
};
